module.exports = __webpack_public_path__ + "img/2018-champions.b164cc15.jpg";